import { Pipe, PipeTransform } from '@angular/core';
import { WidgetType } from 'src/app/models/dashboard';

@Pipe({
  name: 'getWidgetType'
})
export class GetWidgetTypePipe implements PipeTransform {

  transform(type: string, widgetTypes: WidgetType[]): WidgetType {
    for (let widget of widgetTypes) {
      if (widget.type === type) {
        return widget;
      }
    }
    console.log("Could not find WidgetType of " + type);
    return null;
  }
}
